export const ClockAlert = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.979943 3.14645C0.784681 3.34171 0.784681 3.65829 0.979943 3.85355C1.1752 4.04882 1.49179 4.04882 1.68705 3.85355L3.68705 1.85355C3.88231 1.65829 3.88231 1.34171 3.68705 1.14645C3.49179 0.951184 3.1752 0.951184 2.97994 1.14645L0.979943 3.14645Z"
      fill="currentColor"
    />
    <path
      d="M13.0204 1.14645C12.8251 0.951185 12.5085 0.951185 12.3133 1.14645C12.118 1.34171 12.118 1.65829 12.3133 1.85355L14.3133 3.85355C14.5085 4.04882 14.8251 4.04882 15.0204 3.85355C15.2156 3.65829 15.2156 3.34171 15.0204 3.14645L13.0204 1.14645Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6668 8C14.6668 11.6819 11.682 14.6667 8.00009 14.6667C4.31819 14.6667 1.33342 11.6819 1.33342 8C1.33342 4.3181 4.31819 1.33333 8.00009 1.33333C11.682 1.33333 14.6668 4.3181 14.6668 8ZM8.00009 4.66667C8.27623 4.66667 8.50009 4.89052 8.50009 5.16667V7.79289L10.187 9.47978C10.3822 9.67504 10.3822 9.99162 10.187 10.1869C9.99171 10.3821 9.67513 10.3821 9.47987 10.1869L7.64653 8.35355C7.55277 8.25979 7.50009 8.13261 7.50009 8V5.16667C7.50009 4.89052 7.72395 4.66667 8.00009 4.66667Z"
      fill="currentColor"
    />
  </svg>
)

export default ClockAlert
